// A data de confirmação representa um dia civil, sem conversão de fuso horário.
export interface ConfirmationDateValue { confirmed: boolean; date: string | null; }

export function isConfirmationDate(date: unknown): date is string {
  if (typeof date !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(date)) return false;
  const parsed = new Date(date + 'T12:00:00Z');
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === date;
}

export function readConfirmationDateValue(raw: unknown): ConfirmationDateValue | null {
  if (raw == null || raw === '' || raw === false || raw === 'false') return { confirmed: false, date: null };
  // Campos Boolean convertidos para este tipo precisam de uma data escolhida pelo usuario.
  if (raw === true || raw === 'true') return { confirmed: true, date: null };
  try {
    const value = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (!value || typeof value !== 'object' || typeof value.confirmed !== 'boolean') return null;
    if (value.date !== null && typeof value.date !== 'string') return null;
    return { confirmed: value.confirmed, date: value.date };
  } catch { return null; }
}

export function isConfirmationDateValueValid(raw: unknown, required = false): boolean {
  const value = readConfirmationDateValue(raw);
  if (!value) return false;
  return value.confirmed ? isConfirmationDate(value.date) : !required && value.date === null;
}

export function formatConfirmationDate(raw: unknown): string {
  const value = readConfirmationDateValue(raw);
  if (!value?.confirmed || !isConfirmationDate(value.date)) return '—';
  const [year, month, day] = value.date.split('-');
  return '✓ ' + day + '/' + month + '/' + year;
}
